module.exports = __webpack_public_path__ + "static/img/co7.0942410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co7.jpg
// module id = 6FXP
// module chunks = 11